import React, { useState, useEffect } from 'react';
import HeaderRec from '../../../header/headerRec';
import './AddTalent.css';
import { useNavigate } from 'react-router-dom';
import '../../../Entreprise/Missions/MissionsEntreprise.css';
import { useLocation } from 'react-router-dom'; 
import 'react-datepicker/dist/react-datepicker.css';
import { Dialog, Grid, Paper, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, Button, CircularProgress, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CustomAlert from '../../../commun/CustomAlert';
import TalentForm from './TalentForm';
import Step4Form from './Step4Form';
import Step3Form from './Step3Form';
import Step2Form from './Step2Form';
import DashboardLayout from '../../../Admin/Sidebar/DashboardLayout'; 
import axios from 'axios';

export const STEP1_REQUIRED_FIELDS = [
  'nomCandidat',
  'prenomCandidat',
  'email',
  'phone',
  'cvUpload'
];

export const STEP2_REQUIRED_FIELDS = [
  // 'disponibilite'
];

export const STEP3_REQUIRED_FIELDS = [
  // 'niveauEtudes'
];

export const STEP4_REQUIRED_FIELDS = [

];


const AddTalent = () => {
  const [selectedCVName, setSelectedCVName] = useState('');
  const [devise, setDevise] = useState('EUR');
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const location = useLocation(); 
  const [openEmailExistsDialog, setOpenEmailExistsDialog] = useState(false);
  const [existingTalentId, setExistingTalentId] = useState(null); 
  const [formData, setFormData] = useState(null); 

  const [generatedCVs, setGeneratedCVs] = useState({});
  const [selectedCVs, setSelectedCVs] = useState({});
  const [iaModal, setIaModal] = useState({ open: false, talent: null });
  const [autoGenLoading, setAutoGenLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [processing, setProcessing] = useState(true);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [createdTalentId, setCreatedTalentId] = useState(null);

  function parseEducationString(str) {
    const parts = str.split(',').map(s => s.trim());
    const educationObj = {};
  
    parts.forEach(part => {
      const [key, value] = part.split(':').map(s => s.trim());
      educationObj[key] = value;
    });
  
    return educationObj;
  }
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const parsed = params.get('parsed');
  
    if (parsed === 'true') {
      const parsedData = JSON.parse(localStorage.getItem('cvParsedData') || '{}');
      setStep1Data(prev => ({
        ...prev,
        nomCandidat: parsedData.nom || prev.nomCandidat,
        prenomCandidat: parsedData.prenom || prev.prenomCandidat,
        email: parsedData.mail || prev.email,
        phone: parsedData.tel || prev.phone,
        LinkedIn: parsedData.linkedin || prev.LinkedIn,
        trigramme: parsedData.trigramme || prev.trigramme,
        autresLiens: Array.isArray(parsedData.autresLiens) ? parsedData.autresLiens : prev.autresLiens || [],

      }));

      setStep2Data(prev => {
      const updated = {
      ...prev,
        poste: parsedData.poste?.toLowerCase() || prev.poste,
        posteActuelIntitule: parsedData.posteActuelIntitule || prev.posteActuelIntitule,
        entrepriseActuelle: parsedData.entrepriseActuelle || prev.entrepriseActuelle,
        experienceGlobale: parsedData.years_exp || prev.experienceGlobale,
            informationsComplementaires: parsedData.informationsComplementaires || prev.informationsComplementaires || '',

      };

     if (parsedData.dateDebutPoste) {
       const debut = new Date(parsedData.dateDebutPoste);

      const now = new Date();
      const diff = now.getFullYear() - debut.getFullYear();
      updated.anneesPoste = diff.toString();
      }

      return updated;
      });


  
      const educationObj = typeof parsedData.education === 'string'
      ? parseEducationString(parsedData.education)
      : parsedData.education || {};

      setStep3Data(prev => ({
        ...prev,
        niveauEtudes: parsedData.niveau_etude || prev.niveauEtudes,
        titre: educationObj.titre || prev.titre,
        date: educationObj.date || prev.date,
        etablissement: educationObj.établissement || prev.etablissement,
        experienceTalent: parsedData.synthese || prev.experienceTalent,
        pointsEssentiels: typeof parsedData.profil === 'string'
        ? [parsedData.profil]
        : Array.isArray(parsedData.profil)
          ? parsedData.profil
          : prev.pointsEssentiels,
        competences: Array.isArray(parsedData.mot_cles) ? parsedData.mot_cles : prev.competences,    
        langues: Array.isArray(parsedData.langues) ? parsedData.langues : prev.langues,
    
      }));
  
      const fileData = JSON.parse(localStorage.getItem('cvFileFromModal') || '{}');
      if (fileData?.base64 && fileData?.name && fileData?.type) {
        const byteString = atob(fileData.base64.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
  
        const blob = new Blob([ab], { type: fileData.type });
        const reconstructedFile = new File([blob], fileData.name, { type: fileData.type });
  
        setStep1Data(prev => ({
          ...prev,
          cvUpload: [...prev.cvUpload, reconstructedFile], 
        }));
  
        setSelectedCVName(fileData.name); 
      }
  
      localStorage.removeItem('cvParsedData');
      localStorage.removeItem('cvFileName');
      localStorage.removeItem('cvFileFromModal');
    }
  }, [location.search]);
  

  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const userType = localStorage.getItem("userType");
  const [currentStep, setCurrentStep] = useState(1);
  const [step1Errors, setStep1Errors] = useState({});
  const [step2Errors, setStep2Errors] = useState({});
  const [step3Errors, setStep3Errors] = useState({});
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [notesGlobales, setNotesGlobales] = useState('');

  const handleExtractDataFromCV = async () => {
    const files = step1Data.cvUpload;
  
    if (!files || files.length === 0) {
      setStep1Errors(prev => ({ ...prev, cvUpload: "Veuillez ajouter un ou plusieurs CV avant l'extraction." }));
      return;
    }
  
    setSelectedCVName(files.map(file => file.name).join(', '));
  
    for (const file of files) {
      const reader = new FileReader();
  
      reader.onload = async () => {
        const base64 = reader.result.split(',')[1];
        const payload = {
          name: file.name,
          type: file.type,
          file: base64,
        };
  
        try {
          const response = await fetch('https://www.cooptaleo.com/jsoncv', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
  
          const data = await response.json();
  
          if (!data) {
            setAlertMessage(`Erreur : aucune donnée extraite pour le fichier ${file.name}.`);
            setAlertSeverity("error");
            setAlertOpen(true);
            return;
          }
  
          setStep1Data(prev => ({
            ...prev,
            nomCandidat: data.nom || prev.nomCandidat,
            prenomCandidat: data.prenom || prev.prenomCandidat,
            email: Array.isArray(data.mail)? data.mail: data.mail ? [data.mail]: prev.email,
            phone: Array.isArray(data.tel)? data.tel: data.tel? [data.tel] : prev.phone,
            LinkedIn: data.linkedin || prev.LinkedIn,
            trigramme: data.trigramme || prev.trigramme,
            autresLiens: Array.isArray(data.autresLiens) ? data.autresLiens : prev.autresLiens || [],

          }));
  
          setStep2Data(prev => ({
            ...prev,
            experienceGlobale: data.years_exp || prev.experienceGlobale,
            informationsComplementaires: data.informationsComplementaires || prev.informationsComplementaires || '',

          }));
  
          setStep3Data(prev => ({
          ...prev,
          niveauEtudes: data.niveau_etude || prev.niveauEtudes,
          experienceTalent: data.synthese || prev.experienceTalent,
          pointsEssentiels: typeof data.profil === 'string'
          ? [data.profil]
          : Array.isArray(data.profil)
          ? data.profil
          : prev.pointsEssentiels,
          competences: Array.isArray(data.mot_cles) ? data.mot_cles : prev.competences,
          langues: Array.isArray(data.langues) ? data.langues : prev.langues,
          }));

  
        } catch (err) {
          setAlertMessage(`Erreur lors de l'extraction des données du fichier ${file.name}.`);
          setAlertSeverity("error");
          setAlertOpen(true);
        }
      };
  
      reader.readAsDataURL(file);
    }
  };
  
  
    //step1
    const [step1Data, setStep1Data] = useState({
      nomCandidat: '',
      prenomCandidat: '',
      email: [],
      phone: [],
      trigramme: '',
      cvUpload: [],
      autresLiens: [],
    });
  
    //step2
    const [step2Data, setStep2Data] = useState({
      poste: '',  
      posteActuelIntitule: '',
      entrepriseActuelle: '',
      anneesPoste: '',
      experienceGlobale: '',
      informationsComplementaires: '',
      disponibilite: null,  
    });
  
    //step3
    const [step3Data, setStep3Data] = useState({
      niveauEtudes: '',
      titre: '',
      date: '',
      etablissement: '',
      experienceTalent: '',
      pointsEssentiels: '',
      competences: [],
      langues: [
        {
          langue: '',
          niveau: ''
        }
      ],
    });
  
    //step4 
    const [step4Data, setStep4Data] = useState({
      postesRecherches: '',
      typesContrat: [], 
      remunerations: {} ,
      secteurRecherche: '',
      secteurNonRecherche: '',
      travailSouhaite: '',
      lieuxSouhaites: '',
      etatRecherche: '',
      autresProcessus: '',
    });
    

  
  function StepIndicator({ currentStep, goToStep }) {
    return (
      <div className="div16 step-indicator">
        {[1, 2, 3,4].map((step) => (
          <React.Fragment key={step}>
            <div
              className={`step-circle ${currentStep === step ? 'active-step' : ''} steps-indicator` }
              onClick={() => goToStep(step)}
            >
              {step}
            </div>
            {step < 4 && <div className="step-line" />}
          </React.Fragment>
        ))}
      </div>
    );
  }
  const goToNextStep = () => setCurrentStep((prev) => prev + 1);
  const goToPreviousStep = () => setCurrentStep((prev) => prev - 1);
  const handleStepClick = (step) => {
    if (step === 1) {
      setCurrentStep(1);
    } else if (step === 2) {
      if (validateStep(1)) {
        setCurrentStep(2);
      } else {
        setCurrentStep(1); 
      }
    } else if (step === 3) {
      if (validateStep(1) && validateStep(2)) {
        setCurrentStep(3);
      } else if (!validateStep(1)) {
        setCurrentStep(1);
      } else {
        setCurrentStep(2);
      }
    }
    else if (step === 4) {
      if (validateStep(1) && validateStep(2) && validateStep(3)) {
        setCurrentStep(4);
      } else if (!validateStep(1)) {
        setCurrentStep(1);
      } else if (!validateStep(2)) {
        setCurrentStep(2);
      } else {
        setCurrentStep(3);
      }
    }}

    const validateStep = (step) => {
      if (step === 1) {
        const newErrors = {};
      
        STEP1_REQUIRED_FIELDS.forEach((field) => {
          if (field === 'cvUpload') {
            if (!step1Data.cvUpload || !step1Data.cvUpload[0]) {
              newErrors[field] = 'Veuillez ajouter au moins un CV';
            }
          }
           else if (!step1Data[field]) {
            newErrors[field] = 'Veuillez remplir ce champ';
          }
        });
      
        setStep1Errors(newErrors);
        return Object.keys(newErrors).length === 0;
      }      
    
    if (step === 2) {
      const newErrors = {};
      STEP2_REQUIRED_FIELDS.forEach(([key, value]) => {
        if (!value) newErrors[key] = 'Veuillez remplir ce champ';
      });
      setStep2Errors(newErrors); 
      return Object.keys(newErrors).length === 0;
    }
    if (step === 3) {
      const newErrors = {};
      STEP3_REQUIRED_FIELDS.forEach(([key, value]) => {
        if (!value) newErrors[key] = 'Veuillez remplir ce champ';
      });
      setStep3Errors(newErrors); 
      return Object.keys(newErrors).length === 0;
    }
  
    return true;
  };

  const handleAddNote = async (talentId, noteContent) => {
    if (!noteContent.trim()) return;
  
    try {
      const endpoint = userType === 'admin'
        ? `${API_BASE}/api/admin/candidat/${talentId}/note`
        : `${API_BASE}/api/recruteur/talent/${talentId}/note`;
  
      await axios.put(endpoint, { note: noteContent.trim() });
    } catch (err) {
      console.error("Erreur lors de l'ajout automatique de la note :", err);
    }
  };
  
  const handleGenerateCVAuto = async (talent) => {
    setAutoGenLoading(true);
    setIaModal({ open: true, talent });
    try {
      // 1. Récupération du CV original
      const response = await fetch(`${API_BASE}/api/recruteur/uploads/${talent.cvUpload}`);
      if (!response.ok) throw new Error("Impossible de récupérer le CV.");
      const cvBlob = await response.blob();

      // 2. Envoi à l'API corrections pour extraction
      const formData = new FormData();
      formData.append('file', cvBlob, talent.cvUpload);
      formData.append('choice', 'option1');
      const extractionRes = await fetch('https://www.cooptaleo.com/corrections/', {
        method: 'POST',
        body: formData,
      });
      const extractionData = await extractionRes.json();
      if (extractionData.status !== 'success') throw new Error("Erreur lors de l'extraction du CV");

      const corrections = extractionData.data;

      // 3. Sauvegarde des corrections dans la base (JSON)
      const saveRes = await fetch('https://server.cooptaleo.com/api/cv-corrections/save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          talentId: talent._id,
          data: corrections,
          userId: localStorage.getItem('userId'),
        }),
      });
      if (!saveRes.ok) throw new Error("Erreur lors de la sauvegarde des corrections");


      // 4. Génération du PDF anonymisé via API Flask
      const genRes = await fetch('https://www.cooptaleo.com/corrections/user-corrections', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...corrections, choice: 'option1' }),
      });
      if (!genRes.ok) throw new Error("Erreur lors de la génération du PDF");

      const pdfBlob = await genRes.blob();

      // 5. Upload du fichier PDF dans la base
      const formDataPDF = new FormData();
      formDataPDF.append('file', pdfBlob, 'cv_anonymise.pdf');
      formDataPDF.append('model', 'option1');
      formDataPDF.append('talentId', talent._id);
      formDataPDF.append('name', corrections.name || '');
      formDataPDF.append('title', corrections.title || '');
      formDataPDF.append('userId', localStorage.getItem('userId'));
      formDataPDF.append('recruteurName', localStorage.getItem('recruteurName'));

      const uploadRes = await fetch('https://server.cooptaleo.com/api/cv-generated/save', {
        method: 'POST',
        body: formDataPDF,
      });
      if (!uploadRes.ok) throw new Error("Erreur lors de l'upload du CV généré");

      // 6. Mettre à jour l'historique (fetch cv-generated pour ce talent)
      const reload = await fetch(`${API_BASE}/api/cv-generated/list/${talent._id}`);
      const newCVs = await reload.json();
      setGeneratedCVs(prev => ({ ...prev, [talent._id]: newCVs.data }));

      // 7. Sélectionner automatiquement le dernier CV généré
      const sortedCVs = [...newCVs.data].sort((a, b) =>
        new Date(b.generatedAt || b.date || 0) - new Date(a.generatedAt || a.date || 0)
      );
      const latestCvId = sortedCVs[0]?._id;
      setSelectedCVs(prev => ({ ...prev, [talent._id]: latestCvId }));

      setAlert({
        open: true,
        message: "CV anonymisé généré et enregistré avec succès.",
        severity: "success"
      });
    } catch (err) {
      setAlert({ open: true, message: err.message, severity: "error" });
    } finally {
      setIaModal({ open: false, talent: null });
      setAutoGenLoading(false);
    }
  };
  
const handleTalentSubmit = async () => {
  const formData = new FormData();

  formData.append("recruteurId", userId);
  formData.append("origine", userType);
  formData.append("devise", devise);
  formData.append("recruteurName", localStorage.getItem("recruteurName"));
  formData.append("userId", localStorage.getItem("userId"));
  formData.append("note", JSON.stringify([notesGlobales]));

  Object.entries(step1Data).forEach(([key, value]) => {
    if (key === "cvUpload" && Array.isArray(value)) {
      value.forEach(file => formData.append("cvUpload", file));
    } else if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });

  Object.entries(step2Data).forEach(([key, value]) => {
    formData.append(key, value);
  });

  Object.entries(step3Data).forEach(([key, value]) => {
    formData.append(key, JSON.stringify(value));
  });

  Object.entries(step4Data).forEach(([key, value]) => {
    formData.append(key, JSON.stringify(value));
  });

  try {
    const response = await fetch(`${API_BASE}/api/recruteur/add-talent`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (response.ok) {
      handleGenerateCVAuto(data.talent);
      if (notesGlobales && data.talent?._id) {
        await handleAddNote(data.talent._id, notesGlobales);
      }

      // Ouvre la modale
      setCreatedTalentId(data.talent._id);
      setSuccessDialogOpen(true);
    } else if (data.message === "Vous avez déjà enregistré cet email.") {
      navigate(`/Recruteur/talent-detail/${data.talentId}`);
    } else {
      setAlertMessage("Erreur.", data.message);
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  } catch (error) {
    setAlertMessage('Erreur réseau !', error);
    setAlertSeverity("error");
    setAlertOpen(true);
  }
};

// Simulation du traitement backend
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setProcessing(false);
    }, 5000); // Simule 5 secondes d'anonymisation backend

    return () => clearTimeout(timer);
  }, []);
  
  return (
    <Box>
      <CustomAlert
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />
    <Box>
      <Dialog
        open={successDialogOpen}
        fullWidth
        maxWidth="sm"
        PaperProps={{ style: { textAlign: 'center', padding: '20px', borderRadius: '15px' } }}
      >
        <DialogTitle>
          {processing ? (
            <Typography variant="h5" gutterBottom>Traitement en cours...</Typography>
          ) : (
            <Typography variant="h5" gutterBottom color="primary">
              <CheckCircleOutlineIcon fontSize="large" style={{ verticalAlign: 'middle', marginRight: 8 }} />
              Talent ajouté avec succès !
            </Typography>
          )}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            {processing ? (
              <>
                <CircularProgress color="primary" />
                <Typography variant="subtitle1" style={{ marginTop: '20px' }}>
                  Votre talent est en cours d'anonymisation par notre système d'intelligence artificielle. Merci de patienter quelques instants...
                </Typography>
              </>
            ) : (
              <Typography variant="subtitle1">
                Le profil du talent a été anonymisé avec succès. Vous pouvez maintenant consulter les détails ou le propositionner directement.
              </Typography>
            )}
          </DialogContentText>
        </DialogContent>

        {!processing && (
          <DialogActions style={{ justifyContent: 'center', gap: '10px', marginTop: '15px' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/recruteur/talent-detail/${createdTalentId}`)}
            >
              Voir le détail
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate(`/recruteur/Allmissions`)}
            >
              Propositionner le talent
            </Button>
            <Button
              variant="text"
              onClick={() => navigate('/recruteur/add-talent')}
            >
              Ajouter un autre talent
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Box>

      {userType === 'recruteur' ? (
        <>
          <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />
          
        </>
      ) : (
        <DashboardLayout>
          
        </DashboardLayout>
      )}

      <Box className="add-talent-page">
        <Paper className="main-box" elevation={0}>
          <Grid
            container
            spacing={5}
            className={`grid-container ${userType !== 'recruteur' ? 'with-left-margin' : ''}`}
          >
            {/* Colonne Extraction CV */}
            <Grid item xs={12} md={6} className="grid-item">
              <Paper className="cv-section" elevation={0}>
                <Typography variant="h6" className="add-container-title" gutterBottom>
                  📄 Extraire les données du CV
                </Typography>

                {step1Data.cvUpload.length > 0 ? (
                  <>
                    <Typography variant="body2" className="selected-cv-name">
                      Fichier sélectionné : {selectedCVName}
                    </Typography>
                      <iframe
                      title="CV Preview"
                      src={URL.createObjectURL(step1Data.cvUpload[0])}
                      style={{ width: '100%', height: '500px', marginTop: '1rem' }}
                    />
                  </>
                ):(
                <>
                  <label htmlFor="cv-upload-input" className="cv-dropzone">
                    <Box className="cv-upload-box">
                      <Button
                        variant="contained"
                        className="btn-upload"
                        onClick={() => document.getElementById('cv-upload-input').click()}
                      >
                        Sélectionner un CV
                      </Button>
                    </Box>
                  </label>
                  <input
                    id="cv-upload-input"
                    type="file"
                    accept=".pdf"
                    className="hidden-input"
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      if (files.length > 0) {
                        setSelectedCVName(files.map(file => file.name).join(', '));
                        setStep1Data(prev => ({
                          ...prev,
                          cvUpload: files,
                        }));
                      }
                    }}
                  />  
                </>                
                )}


              </Paper>
            </Grid>

            {/* Colonne Formulaire + Notes */}
            <Grid item xs={12} md={6} className="grid-item">
              <Paper className="manual-form-section" elevation={0}>
                <Typography variant="h6" className="add-container-title" gutterBottom>
                  Créer le talent manuellement
                </Typography>

                <StepIndicator currentStep={currentStep} goToStep={handleStepClick} />
                <Typography className="step-counter">Step {currentStep}/4</Typography>

                {currentStep === 1 && (
                  <TalentForm
                    goToNextStep={goToNextStep}
                    formData={step1Data}
                    setFormData={setStep1Data}
                    errors={step1Errors}
                    setErrors={setStep1Errors}
                  />
                )}
                {currentStep === 2 && (
                  <Step2Form
                    goToNextStep={goToNextStep}
                    goToPreviousStep={goToPreviousStep}
                    formData={step2Data}
                    setFormData={setStep2Data}
                    errors={step2Errors}
                    setErrors={setStep2Errors}
                    devise={devise}
                    setDevise={setDevise}
                  />
                )}
                {currentStep === 3 && (
                  <Step3Form
                    goToNextStep={goToNextStep}
                    goToPreviousStep={goToPreviousStep}
                    formData={step3Data}
                    setFormData={setStep3Data}
                    errors={step3Errors}
                    setErrors={setStep3Errors}
                  />
                )}
                {currentStep === 4 && (
                  <Step4Form
                    goToPreviousStep={goToPreviousStep}
                    formData={step4Data}
                    setFormData={setStep4Data}
                    onSubmit={handleTalentSubmit}
                    devise={devise}
                    setDevise={setDevise}
                  />
                )}
              </Paper>

              <Paper className="notes-section" elevation={0}>
                <Typography variant="subtitle1" gutterBottom>
                  📝 Notes internes
                </Typography>
                <textarea
                  value={notesGlobales}
                  onChange={(e) => setNotesGlobales(e.target.value)}
                  placeholder="Ajouter des remarques ou commentaires internes (facultatif)"
                  className="notes-textarea"
                />
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
};



AddTalent.propTypes = {};

AddTalent.defaultProps = {};

export default AddTalent;


